import { AppUpdate, AppUpdateAvailability, FlexibleUpdateInstallStatus } from '@capawesome/capacitor-app-update';
import { Capacitor } from '@capacitor/core';
import { logInAppUpdate } from './analytics';

export async function checkForAppUpdates(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  try {
    const result = await AppUpdate.getAppUpdateInfo();
    if (result.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE) {
      const verCode = result.availableVersionCode ? String(result.availableVersionCode) : 'unknown';
      logInAppUpdate('available', verCode);

      if (result.flexibleUpdateAllowed) {
        logInAppUpdate('started', verCode);
        await AppUpdate.startFlexibleUpdate();

        AppUpdate.addListener('onFlexibleUpdateStateChange', (state) => {
          if (state.installStatus === FlexibleUpdateInstallStatus.DOWNLOADED) {
            logInAppUpdate('downloaded', verCode);
            showUpdateDownloadedBanner();
          }
        });
      } else if (result.immediateUpdateAllowed) {
        logInAppUpdate('started', verCode);
        await AppUpdate.performImmediateUpdate();
      }
    }
  } catch (err) {
    // In local debug APK or outside Play Store, getAppUpdateInfo throws safely
    console.debug('[AppUpdate] update check skipped:', err);
  }
}

function showUpdateDownloadedBanner(): void {
  if (document.getElementById('app-update-banner')) return;

  const banner = document.createElement('div');
  banner.id = 'app-update-banner';
  banner.style.cssText = `
    position: fixed;
    bottom: 24px;
    left: 16px;
    right: 16px;
    background: #1a2a4a;
    color: #ffffff;
    padding: 12px 16px;
    border-radius: 12px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 99999;
    font-size: 0.875rem;
    font-weight: 500;
  `;

  const text = document.createElement('span');
  text.textContent = '🎉 New update downloaded!';

  const btn = document.createElement('button');
  btn.textContent = 'Restart to Apply';
  btn.style.cssText = `
    background: #eab308;
    color: #0f172a;
    border: none;
    padding: 6px 14px;
    border-radius: 8px;
    font-weight: 700;
    font-size: 0.8125rem;
    cursor: pointer;
  `;

  btn.addEventListener('click', () => {
    logInAppUpdate('completed');
    AppUpdate.completeFlexibleUpdate().catch(() => {});
  });

  banner.appendChild(text);
  banner.appendChild(btn);
  document.body.appendChild(banner);
}
